// extracted by mini-css-extract-plugin
export default {"container":"ViewEmployeeGroupForm_container__SsNga","panel":"ViewEmployeeGroupForm_panel__Xxh1+"};